<template>
  <div class="vip-detail-user">
    <el-row :gutter="20" class="margin-bottom">
      <el-col :span="24" class="text-right"></el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="vipDetailUserInfo.users" border style="width: 100%" v-loading="loading">
        <el-table-column prop="userId" :label="$t('vipDetailUser.userId')" align="center"></el-table-column>
        <el-table-column prop="name" :label="$t('vipDetailUser.userName')" align="center"></el-table-column>
        <el-table-column prop="email" :label="$t('vipDetailUser.email')" align="center">
          <template #default="{ row }">
            {{ row.email || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="address" :label="$t('vipDetailUser.address')" align="center">
          <template #default="{ row }">
            {{ row.address || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="tel" :label="$t('vipDetailUser.phone')" align="center"></el-table-column>
        <el-table-column prop="createTime" :label="$t('vipDetailUser.registerTime')" align="center"></el-table-column>
      </el-table>

      <el-pagination class="margin-top" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getShopTelUser } from '@/api/user/vipDetailApi'
//import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'VipDetailUser',
  data() {
    return {
      tel: '',
      vipDetailUserInfo: {
        users: [],
        link: ''
      },
      loading: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },

  methods: {
    open(data) {
      this.tel = data.tel
      this.loadVipDetailUserData()
    },
    loadVipDetailUserData() {
      if (!this.vipDetailUserInfo.link) return

      this.loading = true
      const params = {
        tel: this.vipDetailUserInfo.link,
        page: this.pagination.currentPage,
        row: this.pagination.pageSize
      }

      getShopTelUser(params)
        .then(res => {
          this.vipDetailUserInfo.users = res.data
          this.pagination.total = res.records
          this.loading = false
        })
        .catch(err => {
          console.error('获取用户数据失败:', err)
          this.loading = false
        })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadVipDetailUserData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadVipDetailUserData()
    }
  }
}
</script>

<style scoped>
.vip-detail-user {
  padding: 20px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.margin-top {
  margin-top: 20px;
}

.text-right {
  text-align: right;
}
</style>